
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Music } from 'lucide-react';

interface MobileSidebarHeaderProps {
  onClose: () => void;
}

const MobileSidebarHeader: React.FC<MobileSidebarHeaderProps> = ({ onClose }) => {
  return (
    <div className="p-3 flex justify-between items-center border-b border-[#403E43]/40 bg-black/80 backdrop-blur-sm sticky top-0 z-10">
      <h2 className="text-white font-semibold flex items-center gap-2">
        <Music className="h-4 w-4 text-soundcharts-purple" />
        <span>Studio Tools</span>
      </h2>
      <Button
        variant="outline"
        size="icon"
        onClick={onClose}
        className="text-white hover:text-soundcharts-purple hover:bg-soundcharts-purple/20"
      >
        <ArrowLeft className="h-5 w-5" />
      </Button>
    </div>
  );
};

export default MobileSidebarHeader;
